/* BBG (buyukbeden.com) özel düzeltmeler (toserof) — 2026-07-17
   Beden seçeneklerini büyüklük sırasına dizer (ürün verisinde karışık girilmiş olsa bile).
   Sıra: harf bedenler (XXS→6XL) önce, sonra numerik bedenler (36→38→40...), bilinmeyenler en sonda.
   PDP + hızlı görünüm/quick-add içindeki buton ve dropdown seçicilerde çalışır. */
(function () {
  /* Harf bedenler: XXS < XS < S < M < L < XL(=1XL) < XXL(=2XL) < 3XL ... < 10XL.
     Numerik bedenler: 36, 38, "50 - 52", "54-56" gibi aralıklar ilk sayıya göre. */
  var LETTER_RANK = { 'XXS': -3, 'XS': -2, 'S': -1, 'M': 0, 'L': 1, 'XL': 2, 'XXL': 3, 'XXXL': 4, 'XXXXL': 5 };

  function rank(value) {
    var t = String(value).trim().toLocaleUpperCase('tr').replace(/İ/g, 'I').replace(/\s+/g, '');
    if (LETTER_RANK.hasOwnProperty(t)) return [0, LETTER_RANK[t]];
    var m = t.match(/^([0-9]{1,2})XL$/);            /* 1XL, 2XL, 3XL ... */
    if (m) return [0, parseInt(m[1], 10) + 1];
    m = t.match(/^X{2,}L$/);                        /* XXXXXL gibi */
    if (m) return [0, t.length - 1];
    m = t.match(/^([0-9]+([.,][0-9]+)?)/);          /* 42, 44, "50-52", "54/56" */
    if (m) return [1, parseFloat(m[1].replace(',', '.'))];
    return [2, 0];
  }

  function isSizeName(s) {
    s = String(s || '').replace(':', '').trim().toLocaleLowerCase('tr');
    return s === 'beden' || s === 'size' || s === 'numara' || s.indexOf('beden') === 0;
  }

  function sortChildren(container, items, getValue) {
    var arr = Array.prototype.slice.call(items);
    if (arr.length < 2) return;
    var orig = arr.map(function (el, i) { return { el: el, r: rank(getValue(el)), i: i }; });
    var sorted = orig.slice().sort(function (a, b) {
      return a.r[0] - b.r[0] || a.r[1] - b.r[1] || a.i - b.i;
    });
    var changed = sorted.some(function (o, idx) { return o.el !== orig[idx].el; });
    if (!changed) return; /* zaten sıralı: tekrar dokunma (observer döngüsünü de kırar) */
    sorted.forEach(function (o) { container.appendChild(o.el); });
  }

  function run() {
    /* buton / swatch stili seçiciler */
    document.querySelectorAll('.variant-option--buttons').forEach(function (group) {
      var labelEl = group.querySelector('.variant-option__label-text');
      if (!labelEl || !isSizeName(labelEl.textContent)) return;
      sortChildren(group, group.querySelectorAll(':scope > label'), function (el) {
        var inp = el.querySelector('input');
        return inp ? inp.value : el.textContent;
      });
    });
    /* dropdown stili seçiciler */
    document.querySelectorAll('.variant-option--dropdowns').forEach(function (group) {
      var labelEl = group.querySelector('.variant-option__label-text');
      var sel = group.querySelector('select');
      if (!sel || !labelEl || !isSizeName(labelEl.textContent)) return;
      sortChildren(sel, sel.querySelectorAll('option'), function (el) { return el.value; });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* quick-view modalı ve varyant değişiminde yeniden basılan seçiciler için */
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  /* Carousel resize sigortası: pencere boyutu/yön değişince tüm carousel'leri
     zorla güncelle — resize sırasında yarım kalan slide yerleşimlerini toparlar
     (ör. KATEGORİLERİMİZ bölümünde kartlar arasında boşluk kalması). */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('carousel-slider').forEach(function (c) {
        var s = c.swiperInstance;
        if (s && !s.destroyed) { try { s.update(); } catch (e) { /* sessiz */ } }
      });
    }, 250);
  });
})();

/* Ürün kartı video — BBG.
   - Kart görünür alana girince kaynağı yükler (lazy) ve ilk N saniyeyi sessizce döngüde oynatır (ön izleme).
   - Fare üzerine gelince tam videoyu baştan oynatır; ayrılınca ön izleme moduna döner.
   - Dokunmatik cihazlarda yalnızca ön izleme (ayar kapalıysa hiç oynatmaz).
   - Görünür alandan çıkınca durdurur (pil / veri tasarrufu). */
(function () {
  var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function setup(video) {
    if (video.__bbgSetup) return;
    video.__bbgSetup = true;
    var previewSec = parseFloat(video.getAttribute('data-preview-seconds') || '4');
    var mobilePreview = (video.getAttribute('data-mobile-preview') || 'true') !== 'false';
    var mode = 'idle'; /* idle | preview | full */
    var loaded = false;
    var media = video.closest('.product-card__media') || video.parentElement;

    function ensureSrc() {
      if (loaded) return;
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.src = src;
      video.load();
      loaded = true;
    }
    function safePlay() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay engellendi: sessiz kal */ });
    }
    function startPreview() {
      if (isTouch && !mobilePreview) return;
      ensureSrc();
      mode = 'preview';
      try { video.currentTime = 0; } catch (e) { /* henüz metadata yok */ }
      safePlay();
    }
    function startFull() {
      ensureSrc();
      mode = 'full';
      try { video.currentTime = 0; } catch (e) { /* sessiz */ }
      safePlay();
    }
    function stop() {
      mode = 'idle';
      video.pause();
      video.classList.remove('is-playing');
    }

    video.addEventListener('playing', function () { video.classList.add('is-playing'); });
    video.addEventListener('timeupdate', function () {
      if (mode === 'preview' && video.currentTime >= previewSec) {
        try { video.currentTime = 0; } catch (e) { /* sessiz */ }
      }
    });
    video.addEventListener('error', function () { stop(); video.removeAttribute('data-bbg-card-video'); });

    if (!isTouch && media) {
      media.addEventListener('pointerenter', function () { startFull(); });
      media.addEventListener('pointerleave', function () { if (mode === 'full') startPreview(); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.4) {
            if (mode === 'idle') startPreview();
          } else if (mode !== 'idle') {
            stop();
          }
        });
      }, { threshold: [0, 0.4, 1], rootMargin: '0px 0px 80px 0px' });
      io.observe(video);
      video.__bbgIO = io;
    } else {
      startPreview();
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-bbg-card-video]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  /* Sonsuz kaydırma / filtre sonrası yeni kartlar */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); }, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Lookbook slide ürün paneli — blok ayarı "açık başlat" kapalıysa temanın init() zorlamasını devre dışı bırak.
   (theme.js LookbookSlidePopover.init masaüstünde paneli her zaman açıyor.) */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('lookbook-slide-popover').then(function () {
    var C = customElements.get('lookbook-slide-popover');
    if (!C || C.prototype.__bbgPatched) return;
    C.prototype.__bbgPatched = true;
    var origInit = C.prototype.init;
    C.prototype.init = function () {
      if (this.getAttribute('data-open-default') === 'false') {
        if (this.hasAttribute('open')) this.removeAttribute('open');
        return;
      }
      return origInit.apply(this, arguments);
    };
    document.querySelectorAll('lookbook-slide-popover[data-open-default="false"][open]').forEach(function (el) { el.removeAttribute('open'); });
  });
})();

/* 3 Kas: üst menü açılır paneli ekranın sağından taşıyorsa (ör. sağdaki "Markalarımız") sola kaydır. */
(function () {
  function fit(det) {
    var p = det.querySelector(':scope > .dropdown');
    if (!p) return;
    p.style.marginInlineStart = '';
    var r = p.getBoundingClientRect();
    var tasma = r.right - (document.documentElement.clientWidth - 16);
    if (tasma > 0) p.style.marginInlineStart = -Math.min(tasma, Math.max(0, r.left - 16)) + 'px';
  }
  function bind() {
    document.querySelectorAll('details[is="details-dropdown"][level="top"]').forEach(function (det) {
      if (det.__ykFit) return; det.__ykFit = true;
      det.addEventListener('mouseenter', function () { fit(det); });
      det.addEventListener('toggle', function () { if (det.open) fit(det); });
      det.addEventListener('focusin', function () { fit(det); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
